const Background = () => <div className="css-1c9a4c6"></div>;

export default Background;
